import { api } from "../../../../configs/index";
import { getUrl } from "../../../../services/helper";
import { baseAxios } from "../../../../services/api";
import { setTableLoading } from "../loading/actions";
import {
  SET_KPI_LIST,
  SET_KPI_LIST_META,
  SET_KPI_LIST_FILTER_DATA,
  SET_KPI_LIST_BY_DATE,
  SET_KPI_LIST_BY_HOUR,
  SET_KPI_REPORTS_DATA,
  SET_KPI_STATISTICS,
} from "./types";

export const setKpiList = (payload) => async (dispatch) =>
  dispatch({ type: SET_KPI_LIST, payload });
export const setKpiListMeta = (payload) => async (dispatch) =>
  dispatch({ type: SET_KPI_LIST_META, payload });
export const setKpiListByDate = (payload) => async (dispatch) =>
  dispatch({ type: SET_KPI_LIST_BY_DATE, payload });
export const setKpiListByHour = (payload) => async (dispatch) =>
  dispatch({ type: SET_KPI_LIST_BY_HOUR, payload });
export const setKpiListFilterData = (payload) => async (dispatch) =>
  dispatch({
    type: SET_KPI_LIST_FILTER_DATA,
    payload,
  });
export const setKpiReportsData = (payload) => async (dispatch) =>
  dispatch({ type: SET_KPI_REPORTS_DATA, payload });
export const setKpiStatistics = (payload) => async (dispatch) =>
  dispatch({ type: SET_KPI_STATISTICS, payload });

export const getKpiList =
  ({
    paginationParams = {
      per_page: 25,
      page: 1,
      order: {
        field: null,
        sort: "asc",
      },
    },
    filterFormData = {},
  }) =>
  async (dispatch) => {
    dispatch(setTableLoading(true));

    try {
      const { data } = await baseAxios().get(getUrl(api.leads.kpiList), {
        params: { ...paginationParams, ...filterFormData },
      });
      dispatch(setKpiList(data.items));
      dispatch(setKpiListMeta(data.meta));
      dispatch(setKpiListByDate(data.kpiByDate));
      dispatch(setKpiListByHour(data.kpiByHour));
      dispatch(setKpiListFilterData(data.filters));
    } catch (e) {
      console.error(e);
    } finally {
      dispatch(setTableLoading(false));
    }
  };

export const getKpiReports =
  (filterParams = {}) =>
  async (dispatch) => {
    dispatch(setTableLoading(true));

    try {
      const { data } = await baseAxios().get(getUrl(api.leads.kpiReports), {
        params: filterParams,
      });

      const reportsData = data?.data || data || [];
      dispatch(
        setKpiReportsData(Array.isArray(reportsData) ? reportsData : [])
      );
    } catch (e) {
      console.error("Error fetching KPI reports:", e);
      dispatch(setKpiReportsData([]));
    } finally {
      dispatch(setTableLoading(false));
    }
  };

export const getKpiChartsData =
  (filterParams = {}) =>
  async (dispatch) => {
    try {
      const { data: response } = await baseAxios().get(
        getUrl(api.leads.kpiChartsData),
        {
          params: filterParams,
        }
      );

      const chartsData = response?.data || response;

      if (chartsData) {
        dispatch(
          setKpiStatistics({
            leadsCount: chartsData.leadsCount || 0,
            leadsCountIsManualFalse: chartsData.leadsCountIsManualFalse || 0,
            leadsCountIsManualTrue: chartsData.leadsCountIsManualTrue || 0,
            totalWebAndPhoneConverted:
              chartsData.totalWebAndPhoneConverted || 0,
            totalWebConverted: chartsData.totalWebConverted || 0,
            totalPhoneConverted: chartsData.totalPhoneConverted || 0,
            leadSalesPerson: chartsData.leadSalesPerson || 0,
            percentSalesRep: chartsData.percentSalesRep || 0,
            leadConvertedTodayIsManual:
              chartsData.leadConvertedTodayIsManual || 0,
            leadConvertedTodayIsntManual:
              chartsData.leadConvertedTodayIsntManual || 0,
          })
        );
      }
    } catch (e) {
      console.error("Error fetching KPI charts data:", e);
    }
  };
